import { useTranslation } from 'react-i18next';
import { useGetEosTotalConsumptionQuery } from '@client/api';
import { toNumberString } from '@client/toolkit';
import { ValueBreakdownWrapper } from '../../../../../components/value-break-down/value-break-down-wrapper';
import { DashboardCardContentValue } from '../../../components/DashboardCardContentValue/dashboard-card-content-value';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { ValueBreakdownItem } from '../../../../../components/value-break-down/value-break-down-item';
import { StatsIcon } from '../../../../../components/icons/stats-icon';

import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { DashboardCardContentValueChange } from '../../../components';
import { NoDataWidgetContent } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';

export function TotalEnergyConsumptionWidget() {
  const { t: tWidget } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const { data, isLoading, isError } = useGetEosTotalConsumptionQuery(
    {
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );
  const { total = 0, percentage = 0, buckets = [] } = data ?? {};
  return (
    <DashboardCardWrapper
      to="/reporting/consumption-energy"
      icon={<StatsIcon />}
      title={tWidget('totalEnergyConsumption.title')}
      loading={isLoading}
    >
      {(!isLoading || isError) && total === 0 ? (
        <NoDataWidgetContent noDataText={tWidget('energy.noData')} />
      ) : (
        <div className="flex flex-col gap-2">
          <DashboardCardContentValue value={`${toNumberString(total ?? 0)}`} unit="kWh">
            <DashboardCardContentValueChange value={`${percentage}%`} />
          </DashboardCardContentValue>

          {buckets && buckets.length > 0 && (
            <>
              <span className="text-[0.86625rem] text-white">{tWidget('totalEnergyConsumption.subtitle')}</span>
              <ValueBreakdownWrapper>
                {buckets.map((bucket) => (
                  <ValueBreakdownItem
                    key={bucket.key}
                    value={`${toNumberString(bucket.total ?? 0)}`}
                    label={`${tWidget(`totalEnergyConsumption.valueBreakdown.${bucket.key}.label`)}`}
                    percentage={`${bucket.percentage}`}
                  />
                ))}
              </ValueBreakdownWrapper>
            </>
          )}
        </div>
      )}
    </DashboardCardWrapper>
  );
}
